<!-- Tab panes -->
<div class="card pestanas">
  <div class="card-header">
    <div id="menu">
	    <ul class="nav">
	        <li class="first nav-item tabPlataformaF_element_to_target">

              <a class="nav-link" [class.active]="isLinkActive('platforms')" (click)="onPlatformsTabClicked()"><span class="d-none d-md-block" translate>inv.tabs.platforms</span><span class="d-block d-md-none" translate>inv.tabs.shortPlatforms</span></a>

          </li>
	        <li class="nav-item tabAltaCliente_element_to_target">

              <a class="nav-link" [class.active]="isLinkActive('clients')" (click)="onClientsTabClicked()"><span class="d-none d-md-block" translate>inv.tabs.clients</span><span class="d-block d-md-none" translate>inv.tabs.shortClients</span></a>

          </li>
			<li class="nav-item tabClientesR_element_to_target"><a class="nav-link" [class.active]="isLinkActive('receivers')" (click)="onReceiversTabClicked()"><span class="d-none d-md-block" translate>inv.tabs.receivers</span><span class="d-block d-md-none" translate>inv.tabs.shortReceivers</span></a></li>
	    </ul>
	</div>
  </div>

  <div class="card-body">
	<div class="tab-content" id="myTabContent">
	   <router-outlet></router-outlet>
	</div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-manager/invoicing-services/inv-tabs/inv-tabs.component.html